import { DietaryPreference } from '../types/dietary';

/**
 * Get the display name based on the current language
 * Returns Arabic name if language is 'ar' and Arabic name exists, otherwise returns English name
 */
export const getDisplayDietaryName = (preference: DietaryPreference, language: string): string => {
  if (language === 'ar' && preference.ar?.name) {
    return preference.ar.name;
  }
  return preference.name;
};

/**
 * Get the display description based on the current language
 * Returns Arabic description if language is 'ar' and Arabic description exists, otherwise returns English description
 */
export const getDisplayDietaryDescription = (preference: DietaryPreference, language: string): string => {
  if (language === 'ar' && preference.ar?.description) {
    return preference.ar.description;
  }
  return preference.description || '';
};
